import { SelectOption } from 'src/components/common/Dropdown';
import { SearchFilter } from 'src/services/search';

export enum FilterType {
  Multiselect = 'multiselect',
  Tags = 'tags',
  SearchInput = 'searchinput',
  Language = 'language',
  Facepart = 'facepart',
}

export interface BaseFilterDescription {
  title: string;
  queryField: SearchFilter;
}

export interface FilterMultiselectDescription extends BaseFilterDescription {
  type:
    | FilterType.Multiselect
    | FilterType.Tags
    | FilterType.Language
    | FilterType.Facepart;
  options: SelectOption[];
}

export interface FilterInputDescription extends BaseFilterDescription {
  type: FilterType.SearchInput;
}

export type FilterDescription =
  | FilterMultiselectDescription
  | FilterInputDescription;
